if (!customElements.get('country-currency')) {
	class CountryCurrency extends HTMLElement {
		constructor() {
			super()

			this.sectionId = this.dataset['sectionId']
			this.idPrefix = `${this.sectionId}-ccs`
			this.countryData = JSON.parse(this.querySelector(`#${this.idPrefix}-country-data`).textContent)
			this.sortedCountryData = this.countryData.reduce((acc, { name, code, currency, symbol, continent }) => {
				acc[continent].push([name, code, currency, symbol])
				return acc
			}, {
				Africa: [],
				Asia: [],
				Europe: [],
				'North America': [],
				'Central America': [],
				'South America': [],
				Oceania: []
			})
			this.continents = Object.keys(this.sortedCountryData)

			this.openModal = this.openModal.bind(this);
			this.closeModal = this.closeModal.bind(this);
			this.renderList = this.renderList.bind(this);
			this.renderRail = this.renderRail.bind(this);
			this.updateTrigger = this.updateTrigger.bind(this);
			this.flagEmoji = this.flagEmoji.bind(this);
			this.selectCountry = this.selectCountry.bind(this);

			this.selected = this.countryData.find(({ name }) => name === this.dataset.defaultCountry);
			this.activeContinent = this.selected.continent;
			this.updateTrigger()

			this.rail = this.querySelector(`#${this.idPrefix}-rail`);
			this.list = this.querySelector(`#${this.idPrefix}-list`);
			this.search = this.querySelector(`#${this.idPrefix}-search`);
			this.overlay = this.querySelector(`#${this.idPrefix}-overlay`);
			this.trigger = this.querySelector(`#${this.idPrefix}-trigger`);
			this.closeBtn = this.querySelector(`#${this.idPrefix}-closeBtn`);

			this.trigger.addEventListener('click', this.openModal);
			this.closeBtn.addEventListener('click', this.closeModal);
			this.overlay.addEventListener('click', (e) => {
				if (e.target === this.overlay) this.closeModal();
			});
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') this.closeModal();
			});
			this.search.addEventListener('input', this.renderList);

			this.renderRail();
			this.renderList();
		}

		flagEmoji(cc) {
			return cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
		}

		renderRail() {
			this.rail.innerHTML = this.continents.map(
				(cont) => `
					<button class="rail-btn ${cont === this.activeContinent ? 'active' : ''}" data-continent="${cont}">
					${cont}
					<span class="count">${this.sortedCountryData[cont].length}</span>
					</button>
				`
			).join('');
			this.rail.querySelectorAll('.rail-btn').forEach((btn) => {
				btn.addEventListener('click', () => {
					this.activeContinent = btn.dataset.continent;
					this.search.value = '';
					this.renderRail();
					this.renderList();
				});
			});
		}

		renderList() {
			const q = this.search.value.trim().toLowerCase();
			let entries;
			let grouped = false;

			if (q) {
				entries = this.countryData.filter(
					(c) =>
						c.name.toLowerCase().includes(q) || c.currency.toLowerCase().includes(q) || c.code.toLowerCase().includes(q)
				);
				grouped = true;
			} else {
				entries = this.sortedCountryData[this.activeContinent].map(([name, code, currency, symbol]) => ({
					continent: this.activeContinent,
					name,
					code,
					currency,
					symbol,
				}));
			}

			if (!entries.length) {
				this.list.innerHTML = `<div class="empty">No matches. Try a country name or currency code.</div>`;
				return;
			}

			let html = '';
			let lastContinent = null;
			entries.forEach((c) => {
				if (grouped && c.continent !== lastContinent) {
					html += `<div class="continent-heading">${c.continent}</div>`;
					lastContinent = c.continent;
				}
				const isSelected = this.selected && this.selected.code === c.code;
				html += `
					<button class="country-row ${isSelected ? 'selected' : ''}" data-code="${c.code}">
						<span class="flag">${this.flagEmoji(c.code)}</span>
						<span class="name">${c.name}</span>
						<span class="code">${c.currency}</span>
						<span class="symbol">${c.symbol}</span>
						<span class="stamp-check">✓</span>
					</button>
				`;
			});
			this.list.innerHTML = html;

			this.list.querySelectorAll('.country-row').forEach((row) => {
				row.addEventListener('click', () => {
					this.selected = this.countryData.find((c) => c.code === row.dataset.code);
					this.updateTrigger();
					this.renderList();
					setTimeout(this.closeModal, 180);

					this.selectCountry(this.selected)
				});
			});
		}

		updateTrigger() {
			this.querySelector(`#${this.idPrefix}-triggerFlag`).textContent = this.flagEmoji(this.selected.code);
			this.querySelector(`#${this.idPrefix}-triggerName`).textContent = this.selected.name;
			this.querySelector(`#${this.idPrefix}-triggerCurrency`).textContent = `${this.selected.currency} ${this.selected.symbol}`;
		}

		openModal() {
			this.overlay.classList.add('open');
			this.activeContinent = this.selected ? this.selected.continent : 'Europe';
			this.search.value = '';
			this.renderRail();
			this.renderList();
			setTimeout(() => this.search.focus(), 50);
		}

		closeModal() {
			this.overlay.classList.remove('open');
		}

		selectCountry(country) {
			const form = this.querySelector('form[action="/localization"]');
			form.querySelector('[name="country_code"]').value = country.code;
			form.submit();
		}
	}

	customElements.define('country-currency', CountryCurrency)
}